import * as actions from 'actions';
import {useSelector, useDispatch} from "react-redux";

const useError=()=> {
    const error = useSelector(state => state.error);
    const dispatch = useDispatch();

    const showError=(text)=> {
        console.log(text);
        dispatch(actions.showError({show:true, text}));
    }
    const closeError=()=> {
        dispatch(actions.closeError());
    }

    return {error, showError, closeError};
};

export default useError;